import Button from './button'
import Icon from './icon'

const components = [
  Button,
  Icon
]

const install = function (Vue) {
  components.map(component => {
    Vue.use(component)
  })
}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export {
  install,
  Button,
  Icon
}

export default {
  install
}
